import {apiFetch} from "./General";

export const getTnc = (category, callback, errorCallback) => {

    apiFetch('tnc/by_lang?category=' + category, '', callback, errorCallback);
}
